import React from 'react';
import { SelectOption } from 'global';
import makeStyles from '@mui/styles/makeStyles';
import { RemoveCircle } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import { FormInputSelect, FormInput } from 'components/form';
import { CustomScorecardCriteriaType } from '../../../../../pages/LenderWaterfall/ScorecardBuilder/types';

interface Props {
  values: { name: string | undefined; type: string };
  actions: {
    onRemove: VoidFunction;
    onNameChange: (nextValue: string) => void;
    onTypeChange: (nextValue: CustomScorecardCriteriaType) => void;
  };
}

const customCriteriaTypeOptions: SelectOption<CustomScorecardCriteriaType>[] = [
  { value: CustomScorecardCriteriaType.Text, label: 'Text' },
  { value: CustomScorecardCriteriaType.Number, label: 'Number' },
  { value: CustomScorecardCriteriaType.Currency, label: 'Currency' },
  { value: CustomScorecardCriteriaType.Boolean, label: 'Boolean' },
];

export const CustomCriteriaHeadCell = ({ values, actions }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.headerCellContainer}>
      <Tooltip title="Remove configuration">
        <IconButton size="small" onClick={actions.onRemove}>
          <RemoveCircle sx={{ fontSize: 20 }} color="error" />
        </IconButton>
      </Tooltip>

      <Box className="configurations">
        <FormInputSelect
          size="small"
          variant="outlined"
          value={values.type}
          label="Criteria Type"
          onChange={actions.onTypeChange}
          options={customCriteriaTypeOptions}
        />

        <FormInput
          required
          variant="outlined"
          label="Criteria Name"
          value={values.name ?? ''}
          onChange={actions.onNameChange}
          placeholder="Enter Criteria Name..."
        />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles({
  headerCellContainer: {
    gap: '0.5rem',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2.5rem 1fr',

    '& .configurations': {
      gap: '0.5rem',
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns: '7rem 1fr',
    },
  },
});
